import { Banner } from './components/Banner/Banner';
import { Box } from './components/Box/Box';
import VideoGallery from './components/VideoGallery/VideoGallery';
import Sustentabilidad from './components/Sustentabilidad/Sustentabilidad';

export const HomeHaka = () => {
  return (
    <main>
      <Banner />
      <Box />
      <Sustentabilidad />
      <VideoGallery />
    </main>
  )
}
